'use client'

import { useContext, useState } from 'react'
import {
    Button,
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/react'
import {
    Bars3Icon,
    ChartPieIcon,
    CursorArrowRaysIcon,
    FingerPrintIcon,
    XMarkIcon
} from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { HiSquaresPlus } from "react-icons/hi2";
import { PiBriefcaseMetalFill } from "react-icons/pi";
import { LuUserRoundSearch } from "react-icons/lu";
import { TbAdjustmentsSearch } from "react-icons/tb";
import { IoIosNotifications } from "react-icons/io";
import { FiHome, FiInfo } from "react-icons/fi";
import {
    MdAssignment,
    MdAssignmentTurnedIn,
    MdBookmarkBorder,
    MdDashboard,
    MdHistory,
    MdOutlineWorkHistory,
    MdPeopleOutline,
    MdSupportAgent,
    MdTravelExplore,
    MdWorkOutline,
} from "react-icons/md";
import { TbFilePencil } from "react-icons/tb";
import Logo from '../assets/logo.svg'
import { DataProvider } from '../store/ContextProvider'
import { CgProfile } from "react-icons/cg";
import { BiEdit } from "react-icons/bi";
import { IoLogOut } from "react-icons/io5";
import { renderImgUrl } from '../utils/renderImgUrl'
import { NavLink } from 'react-router-dom'

const products = [
    { name: 'Import Candidates', description: 'Import Bulk Candidates from excel', href: '/import-candidate', icon: ChartPieIcon },
    { name: 'Import Candidate Info', description: `Import Bulk Candidate's Experience & Education from excel`, href: '/import-info', icon: FingerPrintIcon },
    { name: 'Import Resumes', description: 'Encrypt resumes files and update on Database', href: '/import-resume', icon: CursorArrowRaysIcon },
    // { name: 'Process Resume', description: 'Resume AUTO read and import', href: '/process-resume', icon: SquaresPlusIcon },
]

const accountOptions = [
    { name: 'Manage Account', description: '', href: '/account', icon: CgProfile },
    { name: 'Change Password', description: '', href: '/change-password', icon: BiEdit },
    { name: 'Logout', description: '', href: '/logout', icon: IoLogOut },
]
// const callsToAction = [
//   { name: 'Watch demo', href: '#', icon: PlayCircleIcon },
//   { name: 'Contact sales', href: '#', icon: PhoneIcon },
// ]

const empJobs = [
    { name: "Create Jobs", description: 'Create a Job by providing required details', href: '/create-job', icon: HiSquaresPlus },
    { name: "Manage Jobs", description: 'View, Update, and Delete Jobs', href: '/list-jobs', icon: PiBriefcaseMetalFill }
]

const empCandidates = [
    { name: "Search Candidates", description: 'Search Candidates by Name, Email, and Contact.', href: '/list-candidates', icon: LuUserRoundSearch },
    { name: "Pro Search Candidates", description: 'Search Candidates by advanced keyword and Filters.', href: '/pro-search', icon: TbAdjustmentsSearch }
]

const Tickets = [
    { name: "Get Assistance", description: "Raise a Ticket for getting assistance from our Support team.", href: "/raise-ticket", icon: TbAdjustmentsSearch },
    { name: "View Tickets", description: "Track all the previously raise assistance tickets.", href: "/tickets", icon: TbAdjustmentsSearch }
]

export default function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const { isAuth, currentUser } = useContext(DataProvider)

    return (
        <div className={"px-6 md:px-16 lg:px-24 my-2 sticky top-0 z-50"}>
            <header className="bg-white text-white rounded-full shadow-lg max-w-7xl mx-auto">
                <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-2 px-6 sm:px-6 lg:px-8">
                    <div className="flex lg:flex-1">
                        <a href="/" className="-m-1.5 p-1.5 flex gap-2 items-center">
                            <img
                                alt="App Logo"
                                src={Logo}
                                className="h-[55px] md:h-[80px] w-auto"
                            />
                        </a>
                    </div>
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(true)}
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-800"
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon aria-hidden="true" className="size-8" />
                        </button>
                    </div>
                    <PopoverGroup className="hidden lg:flex lg:gap-x-7">


                        {
                            !isAuth &&
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    `text-sm/6 font-semibold ${isActive ? "text-primary-400" : "text-gray-900"
                                    } hover:text-primary-500`
                                }
                            >
                                Home
                            </NavLink>
                        }


                        {
                            !isAuth &&
                            <NavLink
                                to="/browse-jobs"
                                className={({ isActive }) =>
                                    `text-sm/6 font-semibold ${isActive ? "text-primary-400" : "text-gray-900"
                                    } hover:text-primary-500`
                                }
                            >
                                Browse Jobs
                            </NavLink>
                        }



                        {
                            !isAuth &&
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    `text-sm/6 font-semibold ${isActive ? "text-primary-400" : "text-gray-900"
                                    } hover:text-primary-500`
                                }
                            >
                                About
                            </NavLink>
                        }
                        {
                            !isAuth &&
                            <NavLink
                                to="/works"
                                className={({ isActive }) =>
                                    `text-sm/6 font-semibold ${isActive ? "text-primary-400" : "text-gray-900"
                                    } hover:text-primary-500`
                                }
                            >
                                Works
                            </NavLink>
                        }
                        {
                            !isAuth &&
                            <NavLink
                                to="/explore"
                                className={({ isActive }) =>
                                    `text-sm/6 font-semibold ${isActive ? "text-primary-400" : "text-gray-900"
                                    } hover:text-primary-500`
                                }
                            >
                                Explore
                            </NavLink>
                        }

                        {
                            (currentUser.role === "employer" || currentUser.role === "admin") &&
                            <a href="/" className="text-sm/6 font-semibold text-gray-900">
                                Dashboard
                            </a>}


                        {
                            currentUser.role === "admin" &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Imports
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {products.map((item) => (
                                            <div
                                                key={item.name}
                                                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                            >
                                                <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold text-gray-900">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {/* <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                {callsToAction.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-900 hover:bg-gray-100"
                  >
                    <item.icon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                    {item.name}
                  </a>
                ))}
              </div> */}
                                </PopoverPanel>
                            </Popover>}

                        {
                            (currentUser.role === "employer" || currentUser.role === "admin") &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Jobs
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {empJobs.map((item) => {
                                            if (currentUser.role === "admin" && item.name !== "Create Jobs") {
                                                return (
                                                    <div
                                                        key={item.name}
                                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                    >
                                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                            <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                        </div>
                                                        <div className="flex-auto">
                                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                                {item.name}
                                                                <span className="absolute inset-0" />
                                                            </a>
                                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else if (currentUser.role === "employer") {
                                                return (
                                                    <div
                                                        key={item.name}
                                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                    >
                                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                            <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                        </div>
                                                        <div className="flex-auto">
                                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                                {item.name}
                                                                <span className="absolute inset-0" />
                                                            </a>
                                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else return null;
                                        })}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            (currentUser.role === "employer" || currentUser.role === "admin") &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Candidates
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {empCandidates.map((item) => (
                                            <div
                                                key={item.name}
                                                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                            >
                                                <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold text-gray-900">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            currentUser?.role === "job-seeker" &&
                            <a href="/" className="text-sm/6 font-semibold text-gray-900">
                                Browse Jobs
                            </a>
                        }

                        {
                            (!isAuth || currentUser?.role === "job-seeker") &&
                            <NavLink
                                to="/resume-creator"
                                className={({ isActive }) =>
                                    `text-sm/6 font-semibold ${isActive ? "text-primary-400" : "text-gray-900"
                                    } hover:text-primary-500`
                                }
                            >
                                Resume Creator
                            </NavLink>
                        }

                        {
                            (currentUser.role === "employer" || currentUser.role === "job-seeker") &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Tickets
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {Tickets.map((item) => (
                                            <div
                                                key={item.name}
                                                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                            >
                                                <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold text-gray-900">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </PopoverPanel>
                            </Popover>}


                        {
                            currentUser?.role === "job-seeker" &&
                            <a href="/saved-jobs" className="text-sm/6 font-semibold text-gray-900">
                                Saved Jobs
                            </a>}
                        {
                            currentUser?.role === "job-seeker" &&
                            <a href="/applied-jobs" className="text-sm/6 font-semibold text-gray-900">
                                Applied Jobs
                            </a>}
                        {
                            currentUser?.role === "employer" &&
                            <a href="/job-applications" className="text-sm/6 font-semibold text-gray-900">
                                Applications
                            </a>}
                        {
                            currentUser?.role === "admin" &&
                            <a href="/list-users" className="text-sm/6 font-semibold text-gray-900">
                                List Users
                            </a>}

                        {
                            currentUser?.role === "admin" &&
                            <a href="/tickets" className="text-sm/6 font-semibold text-gray-900">
                                Manage Tickets
                            </a>}

                        {
                            currentUser?.role === "admin" &&
                            <a href="/session-history" className="text-sm/6 font-semibold text-gray-900">
                                Log History
                            </a>}


                        {/* <a href="/import-resume" className="text-sm/6 font-semibold text-gray-900">
            Import Resume
          </a>
          <a href="/import-info" className="text-sm/6 font-semibold text-gray-900">
            Import Info
          </a> */}
                        {/* <a href="/manage-candidate" className="text-sm/6 font-semibold text-gray-900">
            Manage Candidate
          </a> */}

                        {isAuth &&
                            <a href="/notification" className="text-2xl font-semibold text-gray-900">
                                <IoIosNotifications />
                            </a>
                        }

                    </PopoverGroup>
                    <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                        {
                            isAuth &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    <img className='h-11 aspect-square rounded-full' src={renderImgUrl("", "", currentUser.fullName)} alt="profile" />
                                    My Account
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {accountOptions.map((item) => (
                                            <div
                                                key={item.name}
                                                className={`group relative flex items-center gap-x-6 rounded-lg py-1 px-2 text-sm/6 hover:bg-gray-50 ${item.href === "/logout" ? "text-red-500" : "text-gray-900"}`}
                                            >
                                                <div className="flex flex-none p-1 items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold ">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </PopoverPanel>
                            </Popover>
                        }
                        {
                            !isAuth &&
                            <div className='flex gap-4'><Button
                                variant="white"
                                className="w-[100px] h-[38px] text-sm md:text-[16px] text-[#2c25c4] border border-[#2C25C4] rounded-md"
                                onClick={() => window.location.href = "/login"}
                            >
                                Login
                            </Button>

                                <Button
                                    variant="primary"
                                    className="w-[100px] h-[38px] text-white text-sm md:text-[16px] bg-primary-300 rounded-md"
                                    onClick={() => window.location.href = "/signup"}
                                >
                                    Register
                                </Button>
                            </div>
                        }
                    </div>
                </nav>
                <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                    <div className="fixed inset-0" />
                    <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white p-2 sm:p-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                        <div className="flex items-center justify-between">
                            <a href="/" className="-m-1.5 p-1.5 flex gap-1 items-center">
                                <img
                                    alt="App Logo"
                                    src={Logo}
                                    className="h-[50px] w-auto"
                                />
                                {/* <span className="text-lg font-bold text-primary-400">CC Ai</span> */}
                            </a>
                            <button
                                type="button"
                                onClick={() => setMobileMenuOpen(false)}
                                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon aria-hidden="true" className="size-6" />
                            </button>
                        </div>
                        <div className="mt-6 flow-root">
                            <div className="-my-6 divide-y divide-gray-500/10">
                                <div className="space-y-2 py-6">
                                    {
                                        !isAuth &&
                                        <a
                                            href="/"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50 hover:text-primary-400 "
                                        >
                                            <FiHome className="text-lg text-gray-500" />
                                            <span>Home</span>
                                        </a>
                                    }

                                    {
                                        !isAuth &&
                                        <a href="/browse-jobs" className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                            <MdWorkOutline className="text-lg text-gray-500" />
                                            <span>Browse Jobs</span>
                                        </a>
                                    }

                                    {
                                        !isAuth &&
                                        <a
                                            href="/about"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <FiInfo className="text-lg text-gray-500" />
                                            <span>About Us</span>
                                        </a>}

                                    {
                                        !isAuth &&
                                        <a
                                            href="/works"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdOutlineWorkHistory className="text-lg text-gray-500" />
                                            <span>Work</span>
                                        </a>}

                                    {
                                        !isAuth &&
                                        <a
                                            href="/explore"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdTravelExplore className="text-lg text-gray-500" />
                                            <span>Explore</span>
                                        </a>}

                                    {
                                        currentUser.role === "admin" &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                <span className="flex items-center gap-2">
                                                    <ChartPieIcon aria-hidden="true" className="size-5 text-gray-500" />
                                                    Imports
                                                </span>
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {[products].map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className="flex items-center gap-2 rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                    >
                                                        <item.icon aria-hidden="true" className="size-5 text-gray-500" />
                                                        <span>{item.name}</span>
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>}

                                    {
                                        (currentUser.role === "employer" || currentUser.role === "admin") &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                <span className="flex items-center gap-2">
                                                    <PiBriefcaseMetalFill className="text-lg text-gray-500" />
                                                    Jobs
                                                </span>
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {empJobs.map((item) => {
                                                    if (currentUser.role === "admin" && item.name !== "Create Jobs") {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="flex items-center gap-2 rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                <item.icon aria-hidden="true" className="size-5 text-gray-500" />
                                                                <span>{item.name}</span>
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    else if (currentUser.role === "employer") {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="flex items-center gap-2 rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                <item.icon aria-hidden="true" className="size-5 text-gray-500" />
                                                                <span>{item.name}</span>
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    else return null;
                                                })}
                                            </DisclosurePanel>
                                        </Disclosure>}

                                    {
                                        (currentUser.role === "employer" || currentUser.role === "admin") &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                <span className="flex items-center gap-2">
                                                    <LuUserRoundSearch className="text-lg text-gray-500" />
                                                    Candidates
                                                </span>
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {empCandidates.map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className="flex items-center gap-2 rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                    >
                                                        <item.icon aria-hidden="true" className="size-5 text-gray-500" />
                                                        <span>{item.name}</span>
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>}



                                    {
                                        currentUser.role === "job-seeker" &&
                                        <a
                                            href="/"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdWorkOutline className="text-lg text-gray-500" />
                                            <span>Browse Jobs</span>
                                        </a>
                                    }

                                    {
                                        (!isAuth || currentUser?.role === "job-seeker") &&
                                        <a
                                            href="/resume-creator"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <TbFilePencil className="text-lg text-gray-500" />
                                            <span>Resume Creator</span>
                                        </a>
                                    }

                                    {
                                        (currentUser.role === "employer" || currentUser.role === "job-seeker") &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                <span className="flex items-center gap-2">
                                                    <MdSupportAgent className="text-lg text-gray-500" />
                                                    Tickets
                                                </span>
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {Tickets.map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className="flex items-center gap-2 rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                    >
                                                        <item.icon aria-hidden="true" className="size-5 text-gray-500" />
                                                        <span>{item.name}</span>
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>

                                    }

                                    {
                                        currentUser.role === "job-seeker" &&
                                        <a
                                            href="/applied-jobs"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdAssignmentTurnedIn className="text-lg text-gray-500" />
                                            <span>Applied Jobs</span>
                                        </a>}
                                    {
                                        currentUser.role === "job-seeker" &&
                                        <a
                                            href="/saved-jobs"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdBookmarkBorder className="text-lg text-gray-500" />
                                            <span>Saved Jobs</span>
                                        </a>}

                                    {
                                        currentUser.role === "employer" &&
                                        <a
                                            href="/job-applications"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdAssignment className="text-lg text-gray-500" />
                                            <span>Applications</span>
                                        </a>}

                                    {
                                        currentUser.role === "admin" &&
                                        <a
                                            href="/list-users"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdPeopleOutline className="text-lg text-gray-500" />
                                            <span>List Users</span>
                                        </a>
                                    }

                                    {
                                        currentUser.role === "admin" &&
                                        <a
                                            href="/tickets"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdSupportAgent className="text-lg text-gray-500" />
                                            <span>Manage Tickets</span>
                                        </a>
                                    }

                                    {
                                        currentUser.role === "admin" &&
                                        <a
                                            href="/session-history"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <MdHistory className="text-lg text-gray-500" />
                                            <span>Logs History</span>
                                        </a>
                                    }

                                    {
                                        isAuth &&
                                        <a
                                            href="/notification"
                                            className="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                        >
                                            <IoIosNotifications className="text-lg text-gray-500" />
                                            <span>Notifications</span>
                                        </a>}


                                </div>
                                <div className="py-6">
                                    {
                                        isAuth &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                <img className='h-11 aspect-square rounded-full' src={renderImgUrl("", "", currentUser.fullName)} alt="profile" />
                                                My Account
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {accountOptions.map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className={`flex items-center gap-2 rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold hover:bg-gray-50 ${item.href === "/logout" ? "text-red-500" : "text-gray-900"}`}
                                                    >
                                                        <item.icon aria-hidden="true" className="size-5 text-gray-500" />
                                                        <span>{item.name}</span>
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>

                                    }
                                    {
                                        !isAuth &&
                                        <div className='flex gap-5 justify-center'>
                                            <Button
                                                variant="white"
                                                className="w-[200px] h-[38px] text-sm md:text-[16px] text-[#2c25c4] border border-[#2C25C4] rounded-md"
                                                onClick={() => window.location.href = "/login"}
                                            >
                                                Login
                                            </Button>

                                            <Button
                                                variant="primary"
                                                className="w-[200px] h-[38px] text-white text-sm md:text-[16px] bg-primary-300 rounded-md"
                                                onClick={() => window.location.href = "/signup"}
                                            >
                                                Register
                                            </Button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </Dialog>
            </header>
        </div>
    )
}
